import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Navbar } from "./components/navbar/Navbar";
import { theme } from "./globals/theme";
import { Redirect } from "./components/Redirect";
import { Services } from "./pages/cms/services/Services";
import { ServicePage } from "./pages/cms/services/service/Service";
import { Languages } from "./pages/cms/language/Language";
import { useEffect, useState } from "react";
import {
  dictionaryList,
  DocumentContext,
  LanguageContext,
  languageList,
} from "./globals/LanguageContext";
import { Chats } from "./pages/chats/Chats";
import { ChatPage } from "./pages/chats/chatPage/ChatPage";
import { useProfile } from "./stores/useProfile";
import { DarkOverlay } from "./components/darkOverlay/DarkOverlay";
import { LoginForm } from "./components/loginForm/LoginForm";
import { Achievements } from "./pages/cms/achievements/Achievement";
import { AgendaPage } from "./pages/agenda/AgendaPage";
import { Materials } from "./pages/materials/Materials";
import { Projects } from "./pages/projects/projects";
import { ProjectPage } from "./pages/projects/project/project";
import { Invoices } from "./pages/invoices/invoices";
import { DataLoader } from "./components/DataLoader";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { InvoicePage } from "./pages/invoices/invoice/invoice";
import { Quotes } from "@phosphor-icons/react";
import { QuotesPage } from "./pages/quotes/quotes";
import { CreateQuotePage } from "./pages/quotes/createQuote/createQuote";
import { MessagePoppupComponent } from "./components/messagePoppup/MessagePoppup";
import { MessageProvider } from "./components/messagePoppup/MessageContext";
import QRCodeGeneratorMUI from "./components/QrGenerator";
import SelicoLabelGenerator from "./components/QrGenerator";
import { QuoteData } from "./pages/quotes/quoteData/QuoteData";
import { CreateInvoice } from "./components/createInvoice/CreateInvoice";
import { ShipLights } from "./pages/shipLights/ShipLights";
export const App = () => {
  //eslint-disable-next-line
  const [language, setLanguage] = useState("nl_BE");
  const [selectedLanguage, setSelectedLanguage] = useState("documents_nl_BE");
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const { user } = useProfile();

  useEffect(() => {
    !user && setDarkOverlayOpened(true);
  }, [user]);

  return (
    <>
      <DocumentContext.Provider
        value={{
          language: selectedLanguage,
          documentDictionary: languageList[selectedLanguage],
        }}>
        <LanguageContext.Provider
          value={{ language, dictionary: dictionaryList[language] }}>
          <ThemeProvider theme={theme}>
            <MessageProvider>
              <Router>
                {!user && (
                  <DarkOverlay
                    opened={darkOverlayOpened}
                    component={<LoginForm />}
                  />
                )}
                <Navbar />
                <DataLoader />
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/redirect/:path" element={<Redirect />} />
                  <Route path="/agenda" element={<AgendaPage />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/project/:id" element={<ProjectPage />} />
                  <Route path="/materials" element={<Materials />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/invoice/:id" element={<InvoicePage />} />
                  <Route path="/invoice/create" element={<CreateInvoice />} />
                  <Route path="/quotes" element={<QuotesPage />} />
                  <Route path="/quotes/newQuote" element={<QuoteData />} />
                  <Route
                    path="/quote/createQuote/:quoteId/"
                    element={<CreateQuotePage />}
                  />
                  <Route path="/chats" element={<Chats />} />
                  <Route path="/chats/:id" element={<ChatPage />} />
                  <Route path="/cms/services" element={<Services />} />
                  <Route path="/cms/language" element={<Languages />} />
                  <Route path="/cms/services/:id" element={<ServicePage />} />
                  <Route path="/cms/achievements" element={<Achievements />} />
                  <Route path="/qrgen" element={<SelicoLabelGenerator />} />
                  <Route path="/shiplights" element={<ShipLights />} />
                  <Route path="*" element={<></>} />
                </Routes>
              </Router>
              </MessageProvider>
          </ThemeProvider>
        </LanguageContext.Provider>
      </DocumentContext.Provider>
    </>
  );
};
